<template>
  <!--底部菜单-->
  <div class="contactUsBox" v-if="screenType === 'pc' && mobileIsShow">
    <el-image :src="contactUsData.bg" class="contactBg" fit="cover"/>
    <div class="Box1">
      <el-row :gutter="20">
        <el-col :span="10" :offset="4">
          <div class="contactUsBigContentBox">
            <div class="contactUsTip">友情链接</div>
            <div class="contactUsContent">
              <div class="contactUsContentBox" v-for="item in contactUsData.linkList" :key="item"
                   @click="handleBrand(item.jumpUrl,item.title)">
                <el-image :src="fileUrl + item.logo" class="contactUsContentImg" fit="cover"/>
                <div class="contactUsContentTitle SourceHanSansCN-Regular">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="linkBox">
            <div class="officialMediaPlatform SourceHanSansCN-Medium">官方媒体平台</div>
            <div class="officialWeiboBox" @click="handleWeibo">
              <el-image :src="officialWeiboIcon" class="officialWeiboIcon" fit="cover"/>
              <div class="officialWeiboTitle EncodeSansExpanded-Regular">官方微博</div>
            </div>

            <div class="officialWeiboBox officialWeiXinBox">
              <el-image :src="officialWeiXinIcon" class="officialWeiboIcon" fit="cover"/>
              <div class="officialWeiboTitle EncodeSansExpanded-Regular">官方微信公众号</div>
              <el-image :src="wCode" class="wCode"></el-image>
            </div>

            <div class="serviceHotline SourceHanSansCN-Medium">联系我们</div>
            <div class="hotlineNumber EncodeSansExpanded-Regular">400-921-3155</div>
            <div class="serviceEmail EncodeSansExpanded-Regular">Email: afc.cs@stellantisafc.com.cn</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="Box2">
      <div class="recordNumber SourceHanSansCN-Regular" @click="handleFilingCenter">{{
          recordNumber
        }}
      </div>
    </div>
  </div>

  <div class="contactUsBox" v-if="screenType === 'mobile' && mobileIsShow ">
    <el-image :src="mobileBg" class="mobileBg"></el-image>
    <div class="mTip SourceHanSansCN-Bold">友情链接</div>
    <div class="officialWebsiteBox">
      <div class="officialWebsiteContainer" v-for="(item,index) in contactUsData.linkList" :key="index"
           @click="handleBrand(item.jumpUrl,item.title)">
        <!--{{fileUrl+ item.logoMobile}}-->
        <el-image :src="fileUrl + item.logoMobile" class="officialWebsiteIcon"></el-image>
        <div class="officialWebsiteTip">{{ item.title }}</div>
      </div>
    </div>
    <div class="officialMediaPlatform SourceHanSansCN-Bold">官方微信公众号</div>
    <div class="officialWeiboBox" @click="handleWeibo">
      <el-image :src="officialWeiboIcon" class="officialWeiboIcon" fit="cover"/>
      <div class="officialWeiboTitle EncodeSansExpanded-Regular">官方微博</div>
    </div>

    <div class="officialWeiboBox officialWeiXinBox">
      <el-image :src="officialWeiXinIcon" class="officialWeiboIcon" fit="cover" @click="handleShowMobileCode"/>
      <div class="officialWeiboTitle EncodeSansExpanded-Regular" @click="handleShowMobileCode">官方微信公众号</div>
      <el-image :src="wCode" class="wCode fadeIn" v-if="isWcode"></el-image>
    </div>
    <div class="serviceHotline SourceHanSansCN-Medium">联系我们</div>
    <div class="hotlineNumber EncodeSansExpanded-Regular">400-921-3155</div>
    <div class="serviceEmail EncodeSansExpanded-Regular">Email: afc.cs@stellantisafc.com.cn</div>
    <div class="recordNumber SourceHanSansCN-Regular" @click="handleFilingCenter">{{
        recordNumber
      }}
    </div>
  </div>

  <!--<div class="contactUsBox1" v-if="screenType === 'pc' && !mobileIsShow">-->
  <!--  <div class="recordNumber SourceHanSansCN-Regular" @click="handleFilingCenter">©2017 斯泰兰蒂斯汽车金融有限公司-->
  <!--    沪ICP备16013319号-3 本系统支持IPv6访问-->
  <!--  </div>-->
  <!--</div>-->

  <!--<div class="contactUsBox1" v-if="screenType === 'mobile' && !mobileIsShow">-->
  <!--  <div class="recordNumber SourceHanSansCN-Regular" @click="handleFilingCenter">©2017 斯泰兰蒂斯汽车金融有限公司-->
  <!--    沪ICP备16013319号-3 本系统支持IPv6访问-->
  <!--  </div>-->
  <!--</div>-->
</template>
<script setup>
import {defineProps, onMounted, reactive, ref} from "vue";
import {AdaptationScreen, brandList, fileUrl, imgCDN, imgVersion} from "@/common/js/config.default";
import {clickMonitor} from "@/common/js/tools";
import {getBrandList} from "@/http/financialService/financialCalculation";
import {systemConfigList} from "@/http/sys";
import {blogrollList} from "@/http/contactUs/index"

const officialWeiboIcon = ref(imgCDN + 'assets/components/abouts/i1.png?v=' + imgVersion);
const officialWeiXinIcon = ref(imgCDN + 'assets/components/abouts/i2.png?v=' + imgVersion);
const wCode = imgCDN + "assets/components/abouts/wCode.png?v=" + imgVersion;
const mobileBg = imgCDN + 'assets/components/abouts/mobile/bg.png?v=' + imgVersion;
const isWcode = ref(false);

const screenType = ref('pc');

const recordNumber = ref("");
const recordNumberLink = ref("")

const props = defineProps({
  mobileIsShow: {
    type: Boolean,
    default: true
  }
})

const contactUsData = reactive({
  bg: imgCDN + 'assets/home/bMenu/bg.png?v=' + imgVersion,
  linkList: brandList,
  wechatOfficialAccount: imgCDN + 'assets/home/bMenu/wechat.png?v=' + imgVersion,
  wechatVideoAccount: imgCDN + 'assets/home/bMenu/wechatVideo.png?v=' + imgVersion,
})

const handleWeibo = () => {
  window.open("https://weibo.com/u/6072491296")

  clickMonitor({
    event_en: "官方微博—" + title,
    event_cn: "官方微博—" + title,
  })
}

const handleBrand = (e, title) => {
  //window.location.href = e;
  window.open(e)

  clickMonitor({
    event_en: "友情链接_" + title,
    event_cn: "友情链接_" + title,
  })
}

const handleFilingCenter = () => {
  window.open(recordNumberLink.value)
}

const handleShowMobileCode = () => {
  isWcode.value = !isWcode.value;
}


const getBlogrollList = async () => {
  let res = await blogrollList();
  if (res.code === 200) {
    contactUsData.linkList = res.data;
  }
}

const systemConfigListFn = async () => {
  let res = await systemConfigList({
    type: "recordNumber"
  });
  if (res.code === 200) {
    recordNumber.value = res.data[0].content;
    recordNumberLink.value = res.data[0].contentUrl;
  }
}

onMounted(() => {
  //getBrandListFn();
  getBlogrollList();
  systemConfigListFn();
  AdaptationScreen(() => {
    //console.log("手机")
    screenType.value = 'mobile'
  }, () => {
    //console.log("PC")
    screenType.value = 'pc'
  },);
})
</script>
<style scoped lang="scss">
@import "@/common/scss/breakpoints";

.contactUsBox {
  width: 100%;
  height: 582px;
  position: relative;
  overflow: hidden;

  .contactBg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }


  .Box1 {
    width: 100%;
    height: 94%;

    .contentBox {
      //max-width: 1200px;
      margin: 0 auto;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .contactUsBigContentBox {
      width: 100%;
      height: auto;

      .contactUsTip {
        font-size: 25px;
        margin-top: 90.5px;
        z-index: 2;
        color: #fff;
      }

      .contactUsContent {
        //width: 650px;
        width: 100%;
        height: auto;
        margin-top: 50px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .contactUsContentBox {
          width: 160px;
          height: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          //justify-content: space-between;
          margin-bottom: 30px;
          cursor: pointer;

          &:nth-last-child(-n+4) {
            //margin-bottom: 0; /* 要去掉的样式，设置为默认值或所需的值 */
          }
        }

        .contactUsContentImg {
          width: 102px;
          height: auto;
          margin-bottom: 16px;
        }

        .contactUsContentTitle {
          font-size: 18px;
          color: #fff;
        }
      }
    }

    .linkBox {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;


      .officialMediaPlatform {
        font-size: 25px;
        color: #fff;
        margin-top: 106.8px;
      }

      .officialWeiboBox {
        display: flex;
        align-items: center;
        margin-top: 30.7px;
        cursor: pointer;
        position: relative;

        &.officialWeiXinBox {
          margin-top: 12.3px;


          &:hover {
            .wCode {
              opacity: 1;
              transition: all .3s;
            }
          }
        }

        .officialWeiboIcon {
          width: 32px;
          height: 26px;
        }

        .officialWeiboTitle {
          font-size: 20px;
          color: #707070;
          margin-left: 14px;
        }

        .wCode {
          width: 108px;
          height: 108px;
          position: absolute;
          top: -86px;
          left: 200px;
          opacity: 0;
          pointer-events: none;
        }
      }

      .serviceHotline {
        font-size: 25px;
        color: #fff;
        margin-top: 60px;
      }

      .hotlineNumber {
        margin-top: 20px;
        font-size: 20px;
        color: #707070;
      }

      .serviceEmail {
        margin-top: 10px;
        font-size: 20px;
        color: #707070;
      }

      .followUs {
        position: absolute;
        left: 870px;
        top: 374px;
        font-size: 15px;
        color: #fff;
      }

      .wechatOfficialAccountBox {
        width: 120px;
        height: auto;
        position: absolute;
        left: 870px;
        top: 414.5px;

        .wechatOfficialAccountContent {
          width: 120px;
          height: 120px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;

          .wechatOfficialAccountImg {
            width: 104px;
            height: 104px;
          }
        }

        .wechatOfficialAccount {
          width: 120px;
          text-align: center;
          font-size: 13px;
          color: #fff;
          margin-top: 10px;
        }
      }

      .wechatVideoAccountBox {
        left: 1335.5px;
      }
    }
  }

  .Box2 {
    width: 100%;
    height: 6%;

    .recordNumber {
      width: 100%;
      height: auto;
      font-size: 16px;
      color: #fff;
      text-align: center;
      position: relative;
    }
  }
}

.contactUsBox1 {
  width: 100%;
  height: auto;
  //height: 582px;
  position: absolute;
  bottom: 0;
  background: #000;

  .recordNumber {
    width: 100%;
    height: auto;
    font-size: 16px;
    color: #fff;
    text-align: center;
    //position: absolute;
    cursor: pointer;
    //bottom: 10px;
  }
}


@include media-breakpoint-up("md") {
  @import "./index-md.scss";
}
</style>
